// John Eldhose 20180511
const LanguageSelected = (state = [], action) => {
  switch (action.type) {
    case 'LANGUAGE_SELECTED':
      return action.language;
    default:
  }
  return state;
};

export default LanguageSelected;



// WEBPACK FOOTER //
// ./src/reducers/LanguageSelected.js